import CategoryHeader from './CategoryHeader'
import Code from './Code'
import DocsHeader from './DocsHeader'
import DocsTitle from './DocsTitle'

export {
  CategoryHeader,
  Code,
  DocsHeader,
  DocsTitle,
}



// WEBPACK FOOTER //
// ./src/components/index.js